/**
 * HTML 문자열에서 실제 텍스트 노드가 있는지 판단
 * - 멘션, 이미지, 첨부파일 노드는 텍스트로 취급하지 않음
 * - 공백/줄바꿈만 있는 경우도 텍스트 없음으로 판단
 */
export function hasTextContent(htmlContent: string): boolean {
  // 멘션 태그 제거 (data-beautiful-mention 속성을 가진 span)
  const withoutMention = htmlContent.replace(
    /<span[^>]*data-beautiful-mention[^>]*>.*?<\/span>/g,
    '',
  );

  // 첨부파일 태그 제거 (data-name 속성을 가진 a 태그)
  const withoutAttachment = withoutMention.replace(
    /<a[^>]*data-name[^>]*>.*?<\/a>/g,
    '',
  );

  // HTML 태그 전부 제거
  const textOnly = withoutAttachment.replace(/<[^>]+>/g, '');

  // 공백, 줄바꿈 제거 후 실제 텍스트가 있는지 확인
  return textOnly.trim().length > 0;
}
